import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Schedule from "./pages/Schedule";
import Results from "./pages/Results";
import Stats from "./pages/Stats";
import Standings from "./pages/Standings";
import Login from "./pages/Login";

function AppContent() {
    const [token, setToken] = useState(localStorage.getItem("authToken"));
    const [userName, setUserName] = useState(localStorage.getItem("userName"));
    const navigate = useNavigate();
    const location = useLocation();

    const activePage = location.pathname.replace("/", "") || "live";

    const handleLoginSuccess = (tokenValue, userName) => {
        localStorage.setItem("authToken", tokenValue);
        localStorage.setItem("userName", userName);
        setToken(tokenValue);
        setUserName(userName);
        navigate("/");
    };

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userName");
        setToken(null);
        setUserName(null);
        navigate("/login");
    };

    const handleNavigate = (page) => {
        navigate(`/${page}`);
    };

    if (!token) {
        return (
            <Routes>
                <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        );
    }

    return (
        <div>
            <div className="hex-bg"></div>
            <Navbar activePage={activePage} onNavigate={handleNavigate} onLogout={handleLogout} />
            <Routes>
                <Route path="/" element={<Navigate to="/live" />} />
                <Route path="/live" element={<Home token={token} userName={userName} />} />
                <Route path="/results" element={<Results />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/stats" element={<Stats />} />
                <Route path="/standings" element={<Standings />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;